import { render, staticRenderFns } from "./tr-emp.vue?vue&type=template&id=61461307&"
import script from "./tr-emp.vue?vue&type=script&lang=ts&"
export * from "./tr-emp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports